import { Component, EventEmitter, Injector, Input, OnInit, Output } from "@angular/core";
import { forkJoin } from "@node_modules/rxjs/observable/forkJoin";
import { AppComponentBase } from "@shared/common/app-component-base";
import { QrMenaCategoriesServiceProxy, QrMenaCategoryDto } from "@shared/service-proxies/service-proxies";
 

@Component({
    templateUrl:"./categories-container-component.html",
    selector:"qrmena-categories-container"
})
export class CategoriesContainerComponent extends AppComponentBase implements OnInit{
    @Input()isShow:boolean=false
    @Output() hidCanvas =new EventEmitter<boolean>(); 
    @Output() handelSpecificCategoryClick =new EventEmitter<number>(); 
    categories:QrMenaCategoryDto[]=[]
    constructor(injector: Injector,private _categoreiesService:QrMenaCategoriesServiceProxy)
    {
        super(injector);
    }
    ngOnInit(): void {
       // get categories
        forkJoin(this._categoreiesService.getCategories()).subscribe(res=>{
            this.categories=res[0];
        })
    }
    handelCloseCanvas() {
        this.hidCanvas.emit(false)
    }

    handelCategoryClick(cateId:number){
        console.log(cateId)
        this.handelSpecificCategoryClick.emit(cateId)
        //this.isShow=false;
        this.hidCanvas.emit(false);

    }
}


// WEBPACK FOOTER //
// ./src/QrMena/components/categories-container-component/categories-container-component.ts